/**
 * @param url
 * @returns string
 */

export function buildPureUrlViewer (url = '') {
  return `/view/${url.split('?')[0].replace('/imageserver/', '')}`;
}
